const crypto = require('crypto')

const ALGO = 'aes-256-gcm'

/**
 * @description function to encrypt
 * @param {Any} data
 * @param {String} key
 * @returns string
 */
const encrypt = (data, key) => {
  let plainText = data
  if (typeof data == 'object') plainText = JSON.stringify(data)
  const iv = Buffer.from(crypto.randomBytes(12), 'utf8')
  const cipher = crypto.createCipheriv(ALGO, Buffer.from(key, 'hex'), iv)

  let enc = cipher.update(plainText, 'utf8', 'base64')
  enc += cipher.final('base64')

  return JSON.stringify({ content: enc, iv: iv.toString('hex'), tag: cipher.getAuthTag().toString('hex') })
}

/**
 * WRAPPER
 * @description function to decrypt
 * @param {Any} data
 * @param {String} key
 * @returns any
 */
const decrypt = (data, key) => {
  try {
    const encryptedData = typeof data == 'string' ? JSON.parse(data) : data
    const { content, iv, tag } = encryptedData

    const bData = Buffer.from(content, 'base64')
    const tag1 = Buffer.from(tag, 'hex')
    const iv1 = Buffer.from(iv, 'hex')
    const sKey = Buffer.from(key, 'hex')

    const decipher = crypto.createDecipheriv(ALGO, sKey, iv1)
    decipher.setAuthTag(tag1)
    let decrypted = decipher.update(bData, 'utf8')
    decrypted += decipher.final('utf8')
    try {
      return JSON.parse(decrypted)
    } catch (error) {
      return decrypted
    }
  } catch (e) {
    return data
  }
}

/**
 * WRAPPER
 * @description function to hash one or two elements together
 * @param {String} a element to hash
 * @param {String} b (optional) element to concat and hash
 * @returns string
 */
const hash = (a, b = '') => {
  const result = crypto.createHash('sha256').update(a + b, 'utf-8').digest('hex')
  return result
}

module.exports = {
  encrypt,
  decrypt,
  hash,
}
